/**
 * v3.15-1160 — Dual end-of-page CTA used across every public page.
 * Either the visitor is an existing partner (→ Partner Login) or a
 * prospective partner (→ /presentation).
 */
import { Link } from 'react-router-dom';
import { ArrowRight, LogIn } from 'lucide-react';

const EndPageCTA = ({ testId = 'end-page-cta' }) => (
  <section className="bg-slate-900 text-white py-20 px-6" data-testid={testId}>
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-slate-800/60 border border-slate-700 rounded-lg p-8 flex flex-col items-start">
        <p className="text-xs uppercase tracking-[0.2em] text-gold mb-3">Already a Partner?</p>
        <h3 className="font-heading text-2xl font-bold mb-3">Sign in to your Hub.</h3>
        <p className="text-sm text-slate-300 mb-6 leading-relaxed">
          Submit clients, track files, message your Concierge, and watch funding land in real time.
        </p>
        <Link
          to="/login"
          className="mt-auto inline-flex items-center gap-2 bg-white text-slate-900 font-semibold px-5 py-2.5 rounded hover:bg-slate-100 transition-colors"
          data-testid={`${testId}-login`}
        >
          <LogIn className="h-4 w-4" />
          Partner Login
        </Link>
      </div>
      <div className="bg-gradient-to-br from-primary to-slate-800 border border-gold/20 rounded-lg p-8 flex flex-col items-start">
        <p className="text-xs uppercase tracking-[0.2em] text-gold mb-3">Interested in Partnering?</p>
        <h3 className="font-heading text-2xl font-bold mb-3">Become a Prestigious Hub partner.</h3>
        <p className="text-sm text-slate-200 mb-6 leading-relaxed">
          Walk through the partner program in our Presentation — no pressure, no obligation.
        </p>
        <Link
          to="/presentation"
          className="mt-auto inline-flex items-center gap-2 bg-gradient-gold text-slate-900 font-semibold px-5 py-2.5 rounded hover:shadow-gold transition-all"
          data-testid={`${testId}-become-partner`}
        >
          Become a Partner
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default EndPageCTA;
